import React from 'react';
import CryptoArea from './components/CryptoArea/';
import "./styles.scss";

const App = () => (
  <>
    <CryptoArea />
  </>
);

export default App;
